module.exports = "/static-assets/_next/static/images/Poloaroid-9-2c5bde065197b3786dc637ccb943eccf.png";